import './index.css'

import React, { Component } from 'react'
import SpinnerFacebook from '../../components/utils/spinner-facebook'
import axios from 'axios'

class CreateComponent extends Component {
  constructor(props) {
    super(props)

    let resumeData = { hash: '', psw: '' }
    const myStorage = localStorage.getItem('resumeData')

    if (myStorage !== null) {
      resumeData = JSON.parse(myStorage)
    }

    this.state = {
      error: false,
      loadingEdit: false,
      loadingCreate: false,
      hash: resumeData.hash,
      psw: resumeData.psw,
      onFocusHash: false,
      onFocusPsw: false,
    }
  }

  createResumeAction = e => {
    e.preventDefault()

    if (
      window.confirm(
        'This action will remove previous Resume and Password keys in this browser. Do you want to continue?',
      )
    ) {
      this.createResume()
    }
  }

  createResume = e => {
    let state = this.state
    state.loadingCreate = true

    this.setState(state)

    axios
      .post(`${process.env.REACT_APP_API_URL}/resume/create`)
      .then(response => {
        let hash = response.data.resume
        let psw = response.data.psw

        state.loadingCreate = false
        state.hash = hash
        state.psw = psw

        let resumeData = { hash: hash, psw: psw, token: null }
        localStorage.setItem('resumeData', JSON.stringify(resumeData))

        this.setState(state)

        this.props.history.push('/edit')
      })
      .catch(err => {
        alert('There was a error trying to generate your resume')
        state.loadingCreate = false
        state.error = true
        this.setState(state)
      })
  }

  editResume = e => {
    e.preventDefault()

    let state = this.state
    state.loadingEdit = true

    this.setState(state)

    axios
      .post(`${process.env.REACT_APP_API_URL}/resume/validateHashPsw`, {
        hashResume: this.state.hash,
        pswResume: this.state.psw,
      })
      .then(response => {
        let hash = response.data.resume
        let psw = response.data.psw

        state.loadingEdit = false
        state.hash = hash
        state.psw = psw

        let resumeData = { hash: hash, psw: psw, token: null }
        localStorage.setItem('resumeData', JSON.stringify(resumeData))

        this.setState(state)

        this.props.history.push('/edit')
      })
      .catch(err => {
        alert("You are not allowed to access or this content doesn't exist")
        state.loadingEdit = false
        state.error = true
        this.setState(state)
      })
  }

  handleChange = e => {
    const value = e.target.value
    const id = e.target.id
    let state = this.state
    state[id] = value

    this.setState(state)

    let resumeData = { hash: state.hash, psw: state.psw, token: null }
    localStorage.setItem('resumeData', JSON.stringify(resumeData))
  }

  contentCreateButton = () => {
    if (this.state.loadingCreate) {
      return <SpinnerFacebook />
    }

    return <div className="lds-facebook">Create</div>
  }

  contentEditButton = () => {
    if (this.state.loadingEdit) {
      return <SpinnerFacebook />
    }

    return <div className="lds-facebook">Edit</div>
  }

  onFocus = e => {
    const id = e.target.id
    let state = this.state

    if (id === 'hash') {
      state.onFocusHash = true
    }

    if (id === 'psw') {
      state.onFocusPsw = true
    }

    this.setState(state)
  }

  onBlur = e => {
    const id = e.target.id
    let state = this.state
    if (id === 'hash') {
      state.onFocusHash = false
    }

    if (id === 'psw') {
      state.onFocusPsw = false
    }

    this.setState(state)
  }

  render() {
    return (
      <div className="create-home">
        <h2>
          <a
            href="https://makeresume.co"
            target="_blank"
            rel="noreferrer"
            title="Go to makeresume.co"
            className="link-home"
          >
            makeresume.co
          </a>
        </h2>
        <div className="create-home-container right-panel-active" id="container">
          <div className="form-container sign-up-container">
            <form action="#">
              <h1>Edit Resume</h1>
              <span>When you have a resume</span>
              <input
                type="text"
                placeholder="Resume"
                id="hash"
                value={this.state.hash}
                onChange={this.handleChange}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
              />
              <div
                className={`text-input-border-bottom ${this.state.onFocusHash ? 'active' : ''}`}
              />

              <input
                type="text"
                placeholder="Password"
                id="psw"
                value={this.state.psw}
                onChange={this.handleChange}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
              />
              <div
                className={`text-input-border-bottom ${this.state.onFocusPsw ? 'active' : ''}`}
              />

              <button
                disabled={this.state.loadingCreate || this.state.loadingEdit}
                onClick={this.editResume}
              >
                {this.contentEditButton()}
              </button>
            </form>
          </div>

          <div className="overlay-container">
            <div className="overlay">
              <div className="overlay-panel overlay-left">
                <h1>A new one!</h1>
                <p>Make a new Resume</p>
                <button
                  disabled={this.state.loadingCreate || this.state.loadingEdit}
                  onClick={this.createResumeAction}
                  className="ghost"
                  id="signIn"
                >
                  {this.contentCreateButton()}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CreateComponent
